import React, { ChangeEvent } from 'react';
import InputFilterItem from "../../../delivery/components/InputFilterItem";
import { ZipcodeFiltersType } from "../graphql/queries/getZipcodeListing";
import { useTranslation } from 'react-i18next';
import { getSmartLabelClassName } from '../../../../utils/labelWidthUtils';

interface ZipcodeFilterProps {
    filters: ZipcodeFiltersType;
    setFilters: (filters: ZipcodeFiltersType) => void;
}

const ZipcodeFilter: React.FC<ZipcodeFilterProps> = ({
    filters,
    setFilters,
}) => {
    const { t } = useTranslation();
    const colLabels = [
        t('central.zipcodes.filters.zipcode'),
        t('central.zipcodes.filters.state'),
        t('central.zipcodes.filters.city'),
    ];
    const colSpanClassName = getSmartLabelClassName(colLabels);

    return (
        <div className="mb-2 py-2">
            <div className="grid grid-cols-3 gap-x-10 gap-y-4 items-start">
                <div className="min-w-0">
                    <InputFilterItem
                        label={t('central.zipcodes.filters.zipcode')}
                        value={filters.zipcode}
                        onChange={(e: ChangeEvent<HTMLInputElement>) => setFilters({
                            ...filters,
                            zipcode: e.target.value || undefined
                        })}
                        spanClassName={colSpanClassName}
                    />
                </div>
                <div className="min-w-0">
                    <InputFilterItem
                        label={t('central.zipcodes.filters.state')}
                        value={filters.state}
                        onChange={(e: ChangeEvent<HTMLInputElement>) => setFilters({
                            ...filters,
                            state: e.target.value || undefined
                        })}
                        spanClassName={colSpanClassName}
                    />
                </div>
                <div className="min-w-0">
                    <InputFilterItem
                        label={t('central.zipcodes.filters.city')}
                        value={filters.city}
                        onChange={(e: ChangeEvent<HTMLInputElement>) => setFilters({
                            ...filters,
                            city: e.target.value || undefined
                        })}
                        spanClassName={colSpanClassName}
                    />
                </div>
            </div>
        </div>
    );
};

export default ZipcodeFilter;
